<fe-header style="z-index: 10000"></fe-header>
<main>
    <section class="section-alamo-b2b container-fluid py-5 px-0">
        <div class="row align-items-center">
            <!-- Columna izquierda: texto -->
            <div class="col-12 col-lg-6 text-center text-lg-start mb-4 mb-lg-0">
                <h2 class="b2b-title ms-md-5">
                    <span class="highlight">{{
                        'fe_lp_autos_title_1' | translate
                    }}</span
                    ><br />
                    <span class="text-blue">{{
                        'fe_lp_autos_title_2' | translate
                    }}</span>
                </h2>
                <p class="b2b-subtitle ms-md-5">
                    <span class="highlight">{{
                        'fe_lp_autos_subtitle_1' | translate
                    }}</span
                    ><br />
                    <span class="fw-bold">{{
                        'fe_lp_autos_subtitle_2' | translate
                    }}</span>
                </p>
                <a
                    [routerLink]="[]"
                    fragment="sectionForm"
                    class="btn btn-unete fw-bold px-4 py-2 mt-3 ms-md-5"
                >
                    {{ 'fe_lp_autos_cta_join' | translate }}
                </a>
            </div>

            <!-- Columna derecha: imagen -->
            <div class="col-12 col-lg-6 text-center">
                <img
                    [src]="'images/autos-camionetas.png' | cdn"
                    alt="Autos y camionetas"
                    class="img-fluid b2b-img rounded-4"
                />
            </div>
        </div>
    </section>

    <section class="section-flotilla py-5">
        <div class="container-xl">
            <div class="row gy-4">
                <!-- Bloque 1 -->
                <div
                    class="col-12 col-lg-6 d-flex flex-column align-items-start text-start"
                >
                    <div class="d-flex align-items-center mb-3">
                        <img
                            [src]="'images/flota-distintiva.svg' | cdn"
                            alt="Icono flota"
                            class="me-2 icon-img"
                        />
                        <h3 class="title-small mb-0">
                            {{ 'fe_lp_autos_benefit_1_title' | translate }}
                        </h3>
                    </div>
                    <p class="text-description">
                        {{ 'fe_lp_autos_benefit_1_text' | translate }}
                    </p>
                </div>

                <!-- Bloque 2 -->
                <div
                    class="col-12 col-lg-6 d-flex flex-column align-items-start text-start"
                >
                    <div class="d-flex align-items-center mb-3">
                        <img
                            [src]="'images/servicio-excepcional.svg' | cdn"
                            alt="Icono servicio"
                            class="me-2 icon-img"
                        />
                        <h3 class="title-small mb-0">
                            {{ 'fe_lp_autos_benefit_2_title' | translate }}
                        </h3>
                    </div>
                    <p class="text-description">
                        {{ 'fe_lp_autos_benefit_2_text' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </section>

    <section class="section-vehiculos py-5">
        <div class="container-xl text-center">
            <h2 class="vehiculos-title mb-2">
                {{ 'fe_lp_autos_mobility_title' | translate }}
                <span class="text-highlight">{{
                    'fe_lp_autos_mobility_highlight' | translate
                }}</span>
            </h2>

            <fe-carousel-cars></fe-carousel-cars>
        </div>
    </section>

    <section
        class="section-cta-final d-flex align-items-center text-star text-md-center text-white"
    >
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8">
                    <h2 class="cta-text mb-4">
                        {{ 'fe_lp_autos_cta_final_text' | translate }}
                    </h2>
                    <a
                        [routerLink]="[]"
                        fragment="sectionForm"
                        class="btn btn-unete fw-bold px-4 py-2 mt-3"
                    >
                        {{ 'fe_lp_autos_cta_final_button' | translate }}
                    </a>
                </div>
            </div>
        </div>
    </section>

    <section class="renta-form py-5 enterprises" id="sectionForm">
        <div class="container">
            <div class="row align-items-center">
                <!-- Columna Izquierda: Formulario -->
                <div class="col-lg-8">
                    <h2 class="renta-form__title">
                        {{ 'fe_enterprises_form_title_1' | translate }}
                        <span>{{
                            'fe_enterprises_form_title_2' | translate
                        }}</span>
                    </h2>
                    <p class="renta-form__subtitle">
                        {{ 'fe_hbspt_form_subtitle' | translate }}
                    </p>

                    <fe-app-form-enterprises></fe-app-form-enterprises>
                </div>

                <!-- Columna Derecha: Imagen -->
                <div class="col-lg-4 text-center mt-4 mt-lg-0">
                    <img
                        [src]="'images/carro-ilustracion.svg' | cdn"
                        alt="Formulario ilustración"
                        class="img-fluid"
                    />
                </div>
            </div>
        </div>
    </section>

    <fe-blog-cards></fe-blog-cards>
</main>
<fe-footer></fe-footer>
